// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dv-page .dashboard-body {
  padding-bottom: 2rem;
}

.dv-hero__icon {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: rgba(15, 118, 110, 0.4);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
}

.dv-search {
  display: flex;
  gap: 0.65rem;
  align-items: center;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0.85rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.dv-search input {
  flex: 1 1;
  min-width: 0;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 0.7rem 0.85rem;
  font-size: 0.92rem;
  color: #0f172a;
  background: #fff;
}

.dv-search input:focus {
  outline: 2px solid rgba(15, 118, 110, 0.35);
  border-color: #0f766e;
}

.dv-btn {
  border: 0;
  border-radius: 8px;
  padding: 0.7rem 1rem;
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  background: #0f766e;
  color: #fff;
  white-space: nowrap;
}

.dv-btn:hover:not(:disabled) {
  background: #115e59;
}

.dv-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.dv-btn--ghost {
  background: #fff;
  color: #0f172a;
  border: 1px solid #cbd5e1;
}

.dv-btn--ghost:hover:not(:disabled) {
  background: #f8fafc;
}

.dv-btn--small {
  padding: 0.4rem 0.75rem;
  font-size: 0.8rem;
}

.dv-hint,
.dv-error,
.dv-warn,
.dv-empty {
  margin: 0.75rem 0 0;
  font-size: 0.88rem;
}

.dv-hint,
.dv-empty,
.dv-muted {
  color: #64748b;
}

.dv-error {
  color: #b91c1c;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 0.7rem 0.85rem;
}

.dv-warn {
  color: #92400e;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 8px;
  padding: 0.7rem 0.85rem;
}

.dv-table-wrap {
  margin-top: 1rem;
  overflow-x: auto;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.dv-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 720px;
  font-size: 0.84rem;
}

.dv-table th,
.dv-table td {
  padding: 0.7rem 0.75rem;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
  vertical-align: top;
  color: #0f172a;
}

.dv-table th {
  background: #f8fafc;
  color: #475569;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  white-space: nowrap;
}

.dv-table tbody tr:last-child td {
  border-bottom: 0;
}

.dv-chip {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 0.15rem 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  background: #f1f5f9;
  color: #475569;
}

.dv-chip--ok {
  background: #d1fae5;
  color: #065f46;
}

.dv-chip--bad {
  background: #fee2e2;
  color: #991b1b;
}

.dv-chip--pending {
  background: #fef3c7;
  color: #92400e;
}

.dv-chip--sell {
  background: #ffedd5;
  color: #9a3412;
}

.dv-detail-head {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.dv-detail-head h1 {
  margin: 0.35rem 0 0.2rem;
  font-size: 1.45rem;
  color: #0f172a;
}

.dv-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  align-items: center;
  color: #475569;
  font-size: 0.88rem;
}

.dv-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-bottom: 1rem;
}

.dv-tab {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
  border-radius: 999px;
  padding: 0.45rem 0.8rem;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
}

.dv-tab--active {
  background: #0f766e;
  border-color: #0f766e;
  color: #fff;
}

.dv-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.dv-stat {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0.9rem 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.dv-stat span,
.dv-stat small {
  display: block;
  color: #64748b;
  font-size: 0.78rem;
}

.dv-stat strong {
  display: block;
  margin: 0.25rem 0;
  color: #0f172a;
  font-size: 1.05rem;
}

.dv-section {
  margin-top: 1.1rem;
}

.dv-section h2,
.dv-section h3 {
  margin: 0 0 0.55rem;
  font-size: 0.95rem;
  color: #0f172a;
}

.dv-profile {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 0.65rem 1rem;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1rem;
}

.dv-profile dt {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #64748b;
  margin: 0;
}

.dv-profile dd {
  margin: 0.15rem 0 0;
  color: #0f172a;
  font-weight: 600;
}

.dv-level-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-bottom: 0.85rem;
}

.dv-money-stack {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.dv-expand {
  background: #f8fafc;
}

.dv-expand-box {
  padding: 0.35rem 0.2rem 0.6rem;
}

.dv-subhead {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  align-items: baseline;
  margin-bottom: 0.45rem;
}

.dv-pager {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  align-items: center;
  margin-top: 0.75rem;
  color: #475569;
  font-size: 0.82rem;
}

.dv-pager label {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.dv-pager select {
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  padding: 0.3rem 0.4rem;
}

.dv-pager div {
  display: flex;
  gap: 0.4rem;
}

.dv-actions {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

@media (max-width: 720px) {
  .dv-search,
  .dv-detail-head,
  .dv-pager {
    flex-direction: column;
    align-items: stretch;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/System/DownlineViewPage.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;;;EAIE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;;;IAGE,sBAAsB;IACtB,oBAAoB;EACtB;AACF","sourcesContent":[".dv-page .dashboard-body {\n  padding-bottom: 2rem;\n}\n\n.dv-hero__icon {\n  flex-shrink: 0;\n  width: 52px;\n  height: 52px;\n  border-radius: 12px;\n  background: rgba(15, 118, 110, 0.4);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.3rem;\n}\n\n.dv-search {\n  display: flex;\n  gap: 0.65rem;\n  align-items: center;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 0.85rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.dv-search input {\n  flex: 1;\n  min-width: 0;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  padding: 0.7rem 0.85rem;\n  font-size: 0.92rem;\n  color: #0f172a;\n  background: #fff;\n}\n\n.dv-search input:focus {\n  outline: 2px solid rgba(15, 118, 110, 0.35);\n  border-color: #0f766e;\n}\n\n.dv-btn {\n  border: 0;\n  border-radius: 8px;\n  padding: 0.7rem 1rem;\n  font-size: 0.88rem;\n  font-weight: 600;\n  cursor: pointer;\n  background: #0f766e;\n  color: #fff;\n  white-space: nowrap;\n}\n\n.dv-btn:hover:not(:disabled) {\n  background: #115e59;\n}\n\n.dv-btn:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.dv-btn--ghost {\n  background: #fff;\n  color: #0f172a;\n  border: 1px solid #cbd5e1;\n}\n\n.dv-btn--ghost:hover:not(:disabled) {\n  background: #f8fafc;\n}\n\n.dv-btn--small {\n  padding: 0.4rem 0.75rem;\n  font-size: 0.8rem;\n}\n\n.dv-hint,\n.dv-error,\n.dv-warn,\n.dv-empty {\n  margin: 0.75rem 0 0;\n  font-size: 0.88rem;\n}\n\n.dv-hint,\n.dv-empty,\n.dv-muted {\n  color: #64748b;\n}\n\n.dv-error {\n  color: #b91c1c;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  padding: 0.7rem 0.85rem;\n}\n\n.dv-warn {\n  color: #92400e;\n  background: #fffbeb;\n  border: 1px solid #fde68a;\n  border-radius: 8px;\n  padding: 0.7rem 0.85rem;\n}\n\n.dv-table-wrap {\n  margin-top: 1rem;\n  overflow-x: auto;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.dv-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 720px;\n  font-size: 0.84rem;\n}\n\n.dv-table th,\n.dv-table td {\n  padding: 0.7rem 0.75rem;\n  text-align: left;\n  border-bottom: 1px solid #e2e8f0;\n  vertical-align: top;\n  color: #0f172a;\n}\n\n.dv-table th {\n  background: #f8fafc;\n  color: #475569;\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.dv-table tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.dv-chip {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 999px;\n  padding: 0.15rem 0.5rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.dv-chip--ok {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.dv-chip--bad {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.dv-chip--pending {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.dv-chip--sell {\n  background: #ffedd5;\n  color: #9a3412;\n}\n\n.dv-detail-head {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n}\n\n.dv-detail-head h1 {\n  margin: 0.35rem 0 0.2rem;\n  font-size: 1.45rem;\n  color: #0f172a;\n}\n\n.dv-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  align-items: center;\n  color: #475569;\n  font-size: 0.88rem;\n}\n\n.dv-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  margin-bottom: 1rem;\n}\n\n.dv-tab {\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  color: #334155;\n  border-radius: 999px;\n  padding: 0.45rem 0.8rem;\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.dv-tab--active {\n  background: #0f766e;\n  border-color: #0f766e;\n  color: #fff;\n}\n\n.dv-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.dv-stat {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 0.9rem 1rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.dv-stat span,\n.dv-stat small {\n  display: block;\n  color: #64748b;\n  font-size: 0.78rem;\n}\n\n.dv-stat strong {\n  display: block;\n  margin: 0.25rem 0;\n  color: #0f172a;\n  font-size: 1.05rem;\n}\n\n.dv-section {\n  margin-top: 1.1rem;\n}\n\n.dv-section h2,\n.dv-section h3 {\n  margin: 0 0 0.55rem;\n  font-size: 0.95rem;\n  color: #0f172a;\n}\n\n.dv-profile {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 0.65rem 1rem;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 1rem;\n}\n\n.dv-profile dt {\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: #64748b;\n  margin: 0;\n}\n\n.dv-profile dd {\n  margin: 0.15rem 0 0;\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.dv-level-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  margin-bottom: 0.85rem;\n}\n\n.dv-money-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.dv-expand {\n  background: #f8fafc;\n}\n\n.dv-expand-box {\n  padding: 0.35rem 0.2rem 0.6rem;\n}\n\n.dv-subhead {\n  display: flex;\n  justify-content: space-between;\n  gap: 0.75rem;\n  align-items: baseline;\n  margin-bottom: 0.45rem;\n}\n\n.dv-pager {\n  display: flex;\n  justify-content: space-between;\n  gap: 0.75rem;\n  align-items: center;\n  margin-top: 0.75rem;\n  color: #475569;\n  font-size: 0.82rem;\n}\n\n.dv-pager label {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.dv-pager select {\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n  padding: 0.3rem 0.4rem;\n}\n\n.dv-pager div {\n  display: flex;\n  gap: 0.4rem;\n}\n\n.dv-actions {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n@media (max-width: 720px) {\n  .dv-search,\n  .dv-detail-head,\n  .dv-pager {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
